<script>
import isMobile from 'ismobilejs'
import LABELS from '@/constants/labels'

export default {
  name: 'PartTab',
  data() {
    return {
      isActive: false,
      positions: [
        { value: 't', text: '上' },
        { value: 'm', text: '中' },
        { value: 'b', text: '下' },
      ],
    }
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    selectedData: {
      type: Object,
      default: () => ({}),
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    mappingLabels() {
      return LABELS
    },
    isMobile() {
      return !isMobile().any
    },
  },
  methods: {
    pickColor() {
      this.$nextTick(() => {
        this.$refs.vcolor && this.$refs.vcolor.show(this.selectedData.color)
      })
    },
    selectPos(pos) {
      this.$emit('select-pos', pos)
    },
    selectColor(color) {
      this.$emit('select-color', color)
    },
    setPartContent(value) {
      this.$emit('select-part', value)
    },
    handleCloseAddScreen() {
      this.$emit('close-add-screen')
    },
    handleAcceptAddScreen() {
      this.$emit('accept-add-screen')
    }
  },
}
</script>

<template>
  <div class="part-content" v-if="selected">
    <div class="position" v-if="data.hasPosition">
      <span>位置</span>
      <ul class="list-item">
        <li
          v-for="(pos, index) of positions"
          :key="`pos${index}`"
          :class="[
            'btn',
            { active: selectedData.position === pos.value },
            { disabled: selectedData.value === 'type-none' },
          ]"
          @click="selectPos(pos.value)"
        >
          {{ pos.text }}
        </li>
      </ul>
    </div>
    <div class="color" v-if="data.hasColor">
      <!-- <div class="subtitle">{{ mappingLabels.colorSubtitle }}</div> -->
      <div class="color-select" v-dragscroll="isMobile">
        <template v-if="data.colors.length > 6">
          <s-choose-item
            v-for="(color, index) of data.colors.slice(0, 5)"
            :key="index"
            :data="color"
            :selected="selectedData.color === color"
            :isColor="true"
            :disabled="selectedData.value === 'type-none'"
            :showText="false"
            @click-item="selectColor"
          />
          <s-choose-item
            :data="
              !data.colors.slice(0, 5).includes(selectedData.color)
                ? selectedData.color
                : ''
            "
            :selected="!data.colors.slice(0, 5).includes(selectedData.color)"
            :isPicker="true"
            :disabled="selectedData.value === 'type-none'"
            :showText="false"
            @click-item="pickColor"
          />
        </template>
        <template v-else>
          <s-choose-item
            v-for="(color, index) of data.colors"
            :key="index"
            :data="color"
            :selected="selectedData.color === color"
            :isColor="true"
            :disabled="selectedData.value === 'type-none'"
            :showText="false"
            @click-item="selectColor"
          />
        </template>
      </div>
    </div>
    <div class="avatar-part-content">
      <div :class="[data.id, 'part', data.hasColor ? 'part-1' : 'part-2']">
        <ul class="list-item">
          <li
            v-for="(part, idx) of data.children"
            :key="`part${idx}`"
            v-show="!part.hide"
            :class="{ active: part.id === selectedData.id }"
          >
            <div class="item-wrap" @click="setPartContent(part)">
              <span
                class="is-color"
                v-if="data.isColor"
                :style="`--bg-color: ${part.value}`"
              ></span>
              <span
                v-else
                class="bg"
                :style="
                  `--bg-x: ${part.x}; --bg-y: ${
                    part.y
                  }; --bgurl: url(${require('@/assets/images/avatar/avatar-ui.png')})`
                "
              ></span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <s-modal-avatar-color
      ref="vcolor"
      v-if="data.hasColor"
      :palette="data.colors.slice(5)"
      @on-change="selectColor"
    />
    <s-navigate-bar
      @leftClick="handleCloseAddScreen"
      @rightClick="handleAcceptAddScreen"
      >{{ mappingLabels.completeText2 }}
    </s-navigate-bar>
  </div>
</template>

<style lang="scss" scoped>
@import 'part-tab.scss';
</style>
